const calculateProportionalConsideration = (
  considerationTotal: number | undefined,
  allocationPercentageDecimal: number,
) => {
  return (considerationTotal ?? 0) * allocationPercentageDecimal;
};

export default calculateProportionalConsideration;
